<template>
  <VModal ref="modal" @modal:hidden="$emit('close')">
    <div class="w-full max-w-3xl mx-auto">
      <BaseCard v-if="!hasSelectedFilterOption" @click.stop>
        <BaseCardBody>
          <FilterOptionList :filter-options="filterOptions" @change="setFilterOption" />
        </BaseCardBody>
      </BaseCard>
      <FilterOption
        v-else
        v-bind="selectedFilterOption"
        @close="clearFilterOption"
        @apply="handleApplyFilterParam"
      />
    </div>
  </VModal>
</template>

<script>
import FilterOptionList from './FilterOptionList.vue';
import FilterOption from './FilterOption.vue';

export default {
  components: {
    FilterOptionList,
    FilterOption,
  },
  props: {
    filterOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedFilterOption: null,
    };
  },
  computed: {
    hasSelectedFilterOption() {
      return this.selectedFilterOption !== null;
    },
  },
  methods: {
    setFilterOption(filterOption) {
      this.selectedFilterOption = filterOption;
    },
    clearFilterOption() {
      this.selectedFilterOption = null;
    },
    handleApplyFilterParam(filterParam) {
      this.$emit('apply', [filterParam]);
      this.$refs.modal.close();
    },
  },
};
</script>
